import(/* webpackMode: "eager" */ "/mnt/volume_ams3_10/sites/atsauktion.se/ats-frontend/releases/100/src/app/[locale]/category/[[...slug]]/ClientPage.tsx")